import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import { ajaxGetOverdueInvoices } from '../../services/reportsService';
import LoadingButton from '../../components/LoadingButton';
import useAlert from '../../hooks/useAlert'
import moment from 'moment';


export default function OverdueInvoices() {
  
  const errorAlert = useAlert(false, 'error');

  const handleDownload = (format) => () => {
    errorAlert.resetAlert();

    let filename = `overdue-invoices_${moment().format('YYYY-MM-DD')}.${format}`;

    // validate filename
    filename = filename.replace(/[\s/\\?%*:|"<>]/g, '');
    
    return ajaxGetOverdueInvoices({ format }, filename)
      .catch((e) => {
        errorAlert.setAlert(e.message);
      });
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <LoadingButton
          size="small"
          variant="contained"
          color="info"
          sx={{ margin: '10px 20px 10px 0' }}
          onClickPromise={handleDownload('pdf')}
        >
          Download in PDF
        </LoadingButton>
        <LoadingButton
          size="small"
          variant="contained"
          color="info"
          sx={{ margin: '10px 0' }}
          onClickPromise={handleDownload('csv')}
        >
          Download in CSV
        </LoadingButton>
      </Grid>
    </Grid>
  );
}
